import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const ImageUrlValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const controlValue = (<string>control?.value)?.split('?');
  const regExp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+(?:png|jpg|jpeg|gif|svg)+$/;
  return control?.value && !regExp?.test(controlValue?.[0]) ? { imageurl: true } : null;
};
